import { createSlice } from '@reduxjs/toolkit';

export const SubscriptionUser = createSlice({
  name: 'SubscriptionUserDetails',
  initialState: {
    flowType: 'prescription',
    notificationPhoneNumber: '',
    email: '',
    referenceId: '',
    notificationSubscription: false,
    hippaConsent: '',
  },
  reducers: {
    SubscriptionUserDetails: (state, action) => {
      state.flowType = action.payload.flowType;
      state.notificationPhoneNumber = action.payload.notificationPhoneNumber;
      state.email = action.payload.email;
      state.referenceId = action.payload.referenceId;
      state.notificationSubscription = action.payload.notificationSubscription;
      state.hippaConsent = action.payload.hippaConsent;
    },
    setHipaaConsent: (state, action) => {
      state.hippaConsent = action.payload;
    },
  },
});

export const { SubscriptionUserDetails, setHipaaConsent } =
  SubscriptionUser.actions;
export const selectHipaaConsent = (state) =>
  state.SubscriptionUserDetails.hippaConsent;

export default SubscriptionUser.reducer;
